import { Util } from "./common";

export class Tester {
    constructor(app) {
        this.Fixture = new Fixture();
        this.Fixture.set("app",app);
    }

    dispose(){
        this.Fixture.clear();
    }
}

Tester.init = (app)=>{
    let tester = Tester.current = window.__tester = new Tester(app); //全局唯一
    Tester.fixture = tester.Fixture;
}

Tester.dispose = ()=>{
    let tester = Tester.current;
    if(tester) tester.dispose();
    Tester.current = null;
    Tester.fixture = null;
}

class Fixture{
    items={}

    set(name,value){
        if(Util.invalid(value)){
            delete this.items[name];
            return;
        }
        this.items[name]=value;
    }

    get(name){
        return this.items[name];
    }

    clear(){
        this.items={};
    }
}